export const PARKING = 'Parking';
export const CENTRE_COMMERCIAL = 'CentreCommercial';
export const ADRESSE = 'Adresse';
export const LIGNE_BUS = 'LigneBus';
export const CLIENT = 'Client';

export const TYPE_EMPLACEMENT = [
  { name: PARKING, libelle: 'emplacement.parking', icon: '/static/img/gabed/emplacement/svg/parking.svg' },
  { name: CENTRE_COMMERCIAL, libelle: 'emplacement.centreCommercial', icon: '/static/img/gabed/emplacement/svg/centreCommercial.svg' },
  { name: ADRESSE, libelle: 'emplacement.adresse', icon: '/static/img/gabed/emplacement/svg/adresse.svg' },
  { name: LIGNE_BUS, libelle: 'emplacement.ligneBus', icon: '/static/img/gabed/emplacement/svg/bus.svg' },
  { name: CLIENT, libelle: 'emplacement.client', icon: '/static/img/gabed/emplacement/svg/client.svg' },
];

export const TYPE_DONNEE_EMPLACEMENT = 'emplacement';
export const TYPE_DONNEE_FACE = 'faces';
export const TYPE_EXPORT_CAFACE = 'FacesCa';
export const TYPE_DONNEE_MATERIEL = 'materiels';
export const TYPE_DONNEE_DISPOSITIF = 'dispositifs';
export const TYPE_EXPORT_DISPOSITIF_TEMPS_FORT = 'tempsFort';

export const EMPLACEMENT = 'emplacement';
export const FACE = 'face';
export const MATERIEL = 'materiel';
export const DISPOSITIF = 'dispositif';

export const COULEUR_DEMONTE = 'is-danger';
export const COULEUR_MONTE = 'is-success';
export const COULEUR_AMONTER_ADEMONTER = 'is-warning';
export const COULEUR_ENCOURS_MONTAGE_DEMONTAGE = 'is-aRenouveler';
export const COULEUR_ARCHIVE = 'is-secondary-icon';
export const COULEUR_ENCOURS_DE_FABRICATION = 'is-info';
export const COULEUR_FABRIQUE = 'is-success';

export const ACTION_TYPE_ARCHIVAGE_DESARCHIVAGE = 'AchivageDesarchivage';
export const ACTION_TYPE_SUPPRESSION = 'Suppression';
export const ACTION_TYPE_DUPLIQUER = 'Dupliquer';
